// PARAQTA — іздеу. 04.10.26: бөлек «Іздеу нәтижелері» (pg-search) беті ӨШІРІЛДІ.
// Екі кіруі де (навтағы #searchInput, лендингтегі #landingSearchInput) жасырын еді,
// ал каталогтың өз іздеуі бар (/api/catalog/search). Екі бөлек іздеу API-і
// қайшы нәтиже бермес үшін енді кез келген іздеу → Кітапхананың іздеуі.

import { show } from '../../core/router.js';

/** Кітапханаға өтіп, іздеу өрісіне сөзді қойып, сол жердегі іздеуді іске қосады. */
export function searchInCatalog(q) {
  q = String(q || '').trim();
  show('catalog');
  if (q.length < 2) return;
  let tries = 0;
  const fill = () => {
    const inp = document.querySelector('#pg-catalog [data-field="catalog-search-input"]');
    // Каталог өз тыңдаушысын жүктелген соң ғана тіркейді (data-bound) — соны күтеміз.
    if (inp && inp.dataset.bound) {
      inp.value = q;
      inp.dispatchEvent(new Event('input', { bubbles: true }));
      return;
    }
    if (++tries < 40) setTimeout(fill, 50);
  };
  fill();
}

export function handleSearch(e) {
  if (e.key !== 'Enter') return;
  const el = document.getElementById('searchInput');
  searchInCatalog(el ? el.value : '');
}

// Ескі атау — бұрынғы шақырулар сынбасын.
export const doSearch = searchInCatalog;

// index.html-дегі inline onkeyup="handleSearch(event)" үшін.
try { window.handleSearch = handleSearch; } catch (_) {}
